angular.module('aprima-core-ui').directive('apTransitionToAppointment',
    ['TransitionToHelper', 'AppointmentTransitionToHelper',
        function (TransitionToHelper, AppointmentTransitionToHelper) {
            'use strict';

            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    function getTransitionFromElement() {
                        return AppointmentTransitionToHelper.getTransition(attrs.apptScheduleType, attrs.patientId, attrs.calendarId, attrs.apptEdit, attrs.apptId);
                    }

                    TransitionToHelper.registerTransitionTo(scope, element, attrs, getTransitionFromElement);
                }
            };
        }]);
